import React from 'react'
import * as S from './styled'

class Button extends React.Component {
    state = { isShowing: false };

    goToPage = () => {
        dataLayer.push({
            event: 'mobile-botaoFlutuante',
            action: 'clicou_btn'
        });
        window.open(this.props.floatingButtonUrl, "_self")
    }

    showBar = () => {
       const { isShowing } = this.state

       if(window.scrollY){
            this.setState({ isShowing: true})
        }else{
            this.setState({ isShowing: false})
        }
    }

    componentDidMount(){
        window.addEventListener('scroll', this.showBar);
    }

    componentWillUnmount(){
        window.removeEventListener('scroll', this.showBar);
    }

    render() {
        const classShow = this.state.isShowing ? '' : 'show';
        return (
            <>
                <S.FloatingButton
                  id="floating-button"
                  data-testeid="floating-button"
                  data-item-text="Agendar"
                  data-item-position="Flutuante"
                  data-current-service="Home"
                  className={`${classShow}`}
                  onClick={this.goToPage}>
                    <span>{this.props.floatingButtonLabel}</span>
                </S.FloatingButton>
            </>
        )
    }

}

export default Button
